import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import ContractDetail from "./pages/ContractDetail";
import WorkReportEntry from "./pages/WorkReportEntry";
import Personnel from "./pages/Personnel";
import Fleet from "./pages/Fleet";
import DocumentUpload from "./pages/DocumentUpload";
import Reports from "./pages/Reports";
import Admin from "./pages/Admin";
import Planning from "./pages/Planning";
import PlanTemplatesEditor from "./pages/PlanTemplatesEditor";
import WorkReportsList from "./pages/WorkReportsList";
import Anomalies from "./pages/Anomalies";
import WeighingTickets from "./pages/WeighingTickets";
import FuelTickets from "./pages/FuelTickets";
import PuntoLimpio from "./pages/PuntoLimpio";
import Workshop from "./pages/Workshop";
import Manual from "./pages/Manual";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-[#F8FAFC]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-[#007934] border-t-transparent rounded-full animate-spin" />
        <p className="text-slate-500 font-medium">Cargando...</p>
      </div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }
  return children;
};

const ChangePasswordGate = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.must_change_password) return <Navigate to="/" replace />;
  return <ChangePassword />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/change-password" element={<ChangePasswordGate />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="contracts/:id" element={<ContractDetail />} />
            <Route path="work-reports" element={<WorkReportsList />} />
            <Route path="work-reports/new" element={<WorkReportEntry />} />
            <Route path="work-reports/:id" element={<WorkReportEntry />} />
            <Route path="personnel" element={<Personnel />} />
            <Route path="fleet" element={<Fleet />} />
            <Route path="documents" element={<DocumentUpload />} />
            <Route path="reports" element={<Reports />} />
            <Route path="admin" element={<Admin />} />
            <Route path="planning" element={<Planning />} />
            <Route path="planning/templates" element={<PlanTemplatesEditor />} />
            <Route path="anomalies" element={<Anomalies />} />
            <Route path="weighing-tickets" element={<WeighingTickets />} />
            <Route path="fuel-tickets" element={<FuelTickets />} />
            <Route path="punto-limpio" element={<PuntoLimpio />} />
            <Route path="workshop" element={<Workshop />} />
            <Route path="manual" element={<Manual />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
